module.exports = __webpack_public_path__ + "37ba7b92/img/chevron-down-icon.5542f65c.svg";